import { apiUrl } from "./client";

/**
 * Downloads a file from the API: the server's file name (RFC 5987 filename* first), or `fallback`. A JSON error
 * body becomes the thrown message. Returns the report version the server recorded, when it is a versioned report.
 */
export async function downloadFile(path: string, fallback: string, body?: unknown): Promise<{ version: number | null }> {
  const res = await fetch(apiUrl(path), {
    method: body ? "POST" : "GET", credentials: "include",
    ...(body ? { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) } : {}),
  });
  if (!res.ok) {
    let message = `Download failed (${res.status})`;
    try { const b = await res.json(); message = b?.error?.message ?? message; } catch { /* not JSON */ }
    throw new Error(message);
  }
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") ?? "";
  const name = decodeURIComponent(/filename\*=UTF-8''([^;]+)/.exec(cd)?.[1] ?? "") || /filename="([^"]+)"/.exec(cd)?.[1] || fallback;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
  const v = Number(res.headers.get("X-Report-Version"));
  return { version: Number.isFinite(v) && v > 0 ? v : null };
}
